import React from 'react'
import { formatMessage } from '@/utils/common'
import './Welcome.less'
const Welcome = () => {
  return (
    <div className="welcome">
      <div className="welcome-logo">
        <span className="nsg-glyph--swoosh" />
      </div>
      <h2 className="welcome-text">{formatMessage('languageObj.welcomeLocale.welcome')}</h2>
    </div>
  )
}

export default Welcome
